export default __webpack_public_path__ + "static/media/logo.fa5bae34.svg";